<template>

	<div class="watch-readings-details">
		<widget-history :class="{ 'visible-mobile': selected == 1 }" :refresh="refreshReadings" :user_uid="user_uid" :watch_id="watch_id" :type_id="type_id"/>
		<widget-measure :class="{ 'visible-mobile': selected == 2 }" :refresh="refreshReadings" :user_uid="user_uid" :watch_id="watch_id" :type_id="type_id"/>
		<widget-latest  :class="{ 'visible-mobile': selected == 3 }" :refresh="refreshReadings" :user_uid="user_uid" :watch_id="watch_id" :type_id="type_id"/>
		
		<widget-alert-parameters v-if="allowParameters()" :user_uid="user_uid" :watch_id="watch_id" :type_id="type_id"/>
		<widget-alert-history v-if="allowHistory()" :user_uid="user_uid" :watch_id="watch_id" :type_id="type_id"/>
		<sub-menu @selected="onSelected"/>
		<router-view/>
	</div>

</template>

<script>
import WidgetMeasure from './widgets/ReadingsWidgetMeasure'
import WidgetLatest from './widgets/ReadingsWidgetLatest'
import WidgetHistory from './widgets/ReadingsWidgetHistory'
import WidgetAlertParameters from './widgets/ReadingsWidgetAlertParameters'
import WidgetAlertHistory from './widgets/ReadingsWidgetAlertHistory'
import SubMenu from './ReadingsDetailsSubMenu'
import Readings from '@/utils/readings'
export default {
	components: {
		WidgetMeasure,
		WidgetLatest,
		WidgetHistory,
		WidgetAlertParameters,
		WidgetAlertHistory,
		SubMenu
	},
	props: [
		'user_uid',
		'watch_id',
		'type_id'
	],
	data () {
		return {
			selected: 1,
			error: null,
			offset: 0,
			limit: 10,
			readings: [],
			interval: null,
			routes: [
				'WatchBiometricView',
				'WatchGeofencing'
			]
		}
	},
	watch: {
		selected (value) {
			this.$nextTick(() => {
				switch (value) {
					case 1:
						this.$root.$emit('force-render-biometric-measure')
						break
					case 3:
						this.$root.$emit('force-render-biometric-chart')
						break
				}
			})
		},
		'$route' (to, from) {
			if ((from.name === to.name) || (this.routes.includes(from.name) && this.routes.includes(to.name))) {
				this.$emit('biometric-details-route-changed')
			}
		}
	},
	methods: {
		refreshReadings () {
			this.$emit('biometric-details-refresh-readings')
		},
		onSelected (selected) {
			this.selected = selected
		},
		allowParameters() {
			if ([Readings.TYPE_CALORIES, Readings.TYPE_PEDOMETER, Readings.TYPE_FALLS].includes(this.type_id))
				return false
			return true
		},
		allowHistory() {
			if ([Readings.TYPE_CALORIES, Readings.TYPE_PEDOMETER].includes(this.type_id))
				return false
			return true
		}
	},
	beforeCreate () {
		this.$title('Readings')
	},
	mounted () {
		let sync = this.$store.state.user.syncReadings * 1000
		this.$log.info('synchronization timer', 'synchronization timer: ', sync)()
		if (Number.isInteger(sync) && sync > 0) {
			if (sync < 5000) {
				sync = 5000
			}
			this.interval = window.setInterval(this.refreshReadings, sync)
			this.$log.info('synchronization timer', 'synchronization timer set to: ', sync)()
		}
	},
	destroyed () {
		window.clearInterval(this.interval)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/ReadingsDetails.vue